const locale ={
    HELP :"Trợ giúp",
    PRIVACY:"Sự riêng tư",
    TERMS:"Điều kiện",
}

export default locale